import type { vtkSubscription } from '@kitware/vtk.js/interfaces';

import { onUnmounted } from 'vue';

export function manageVTKSubscription(subscription: vtkSubscription) {
  onUnmounted(() => subscription.unsubscribe());
}
